export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/CodeWorker.0e178b19.worker.js");
}
